/* eslint-disable no-useless-escape */
export const capitalizeAll = (string: any) => {
  return string?.toUpperCase()
}

export default capitalizeAll
